import styled from "styled-components"

import { SparklesIcon } from "@minuthq/meatball-ui-icons"
import { Text, TextArea } from "@minuthq/meatball-ui-react"
import { useFormik } from "formik"

import {
  useFetchParadiseLLMPromptChangeNotes,
  usePostParadiseLLMPromptVersion,
} from "src/data/paradise/paradiseLLMPrompts/queries/paradiseLLMPromptsQueries"
import { MButton } from "src/ui/Button/MButton"
import { MDialog } from "src/ui/Dialog/MDialog"

type TParadiseAddLLMPromptVersionForm = {
  description: string
}

const FORM_ID = "add-llm-prompt-version-dialog"

export function ParadiseAddLLMPromptVersionDialog({
  onClose,
  promptId,
  prompt,
}: {
  onClose: () => void
  promptId: string
  prompt: string
}) {
  const form = useFormik<TParadiseAddLLMPromptVersionForm>({
    initialValues: {
      description: "",
    },
    onSubmit: handleSave,
  })

  const fetchChangeNotes = useFetchParadiseLLMPromptChangeNotes({
    promptId,
    prompt,
  })

  const postLLMPromptVersion = usePostParadiseLLMPromptVersion()

  function handleSave() {
    postLLMPromptVersion.mutate(
      {
        path: { prompt_id: promptId },
        body: {
          description: form.values.description,
          prompt: prompt,
        },
      },
      {
        onSuccess: () => {
          onClose()
        },
      }
    )
  }

  return (
    <MDialog
      open={true}
      onClose={onClose}
      title={
        <TitleWrapper>
          <Text variant="heading2">Add prompt version</Text>

          <MButton
            startIcon={<SparklesIcon width={16} height={16} />}
            onClick={() => {
              if (fetchChangeNotes.isSuccess) {
                void form.setValues({
                  description: fetchChangeNotes.data.suggested_description,
                })
              }
            }}
            variant="subtle"
            size="small"
            loading={fetchChangeNotes.isLoading}
          >
            Suggest change notes
          </MButton>
        </TitleWrapper>
      }
      confirmLabel="Save"
      confirmButtonProps={{
        loading: postLLMPromptVersion.isPending,
      }}
      closeLabel="Cancel"
      closeButtonProps={{
        disabled: postLLMPromptVersion.isPending,
      }}
      formId={FORM_ID}
      width="large"
    >
      <form onSubmit={form.handleSubmit} id={FORM_ID}>
        <TextArea
          label="Description"
          value={form.values.description}
          onChange={(value) =>
            void form.setValues((prev) => ({ ...prev, description: value }))
          }
          minRows={3}
          required
        />
      </form>
    </MDialog>
  )
}

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
